import React from 'react';

import AllForm from 'components/AllForm'

export const App = () => {
  return (
    <main>
      <AllForm />
    </main>
  )
}